// Shared renderers + payload coercions for the Onboarding tabs.

// renderNormalNumber:0 — thousands separators, 0 decimals; empty for null.
export function renderNormalNumber(value: number | null | undefined, decimals = 0): string {
  if (value == null || Number.isNaN(value)) return '';
  return value.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

// renderPercentage — "${data}%"; empty string for null (legacy renderPercentage).
export function renderPercentage(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '';
  return `${value}%`;
}

// renderTruncatedList:3 — join a comma/other separated string, show first N then "+K".
export function renderTruncatedList(value: string | null | undefined, max = 3): string {
  if (!value) return '';
  const parts = value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length <= max) return parts.join(', ');
  return `${parts.slice(0, max).join(', ')} +${parts.length - max}`;
}

// Parse a possibly comma-formatted numeric string → number | null (empty => null).
export function parseFloatOrNull(v: string): number | null {
  if (v === '' || v == null) return null;
  const n = Number.parseFloat(String(v).replace(/,/g, ''));
  return Number.isNaN(n) ? null : n;
}

export function parseIntOrZero(v: string): number {
  const n = Number.parseInt(String(v).replace(/,/g, ''), 10);
  return Number.isNaN(n) ? 0 : n;
}
